import styled from 'styled-components/macro';

export const ModalWrapper = styled('div')`
  z-index: 2700;
  position: fixed;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.31);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  top: 0px;
  bottom: 0;
`;

export const ModalInner = styled('div')`
  width: 100%;
  max-width: 670px;
  position: relative;
  height: 500px;
  background: #fff;
  box-shadow: 0 0 50px rgba(0, 0, 0, 0.15);
  margin-top: 100px;
  height: auto;
  padding-top: 40px;
`;

export const UploaderView = styled('div')`
  .block__wrapper {
    table {
      border: 1px solid #eee;
    }
  }
  .block__hover {
    margin-top: 10px !important;
    .block__content {
      line-height: normal;
    }
    .block__wrapper {
      border: 1px solid rgba(0, 0, 0, 0.05);
      box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05);
    }
  }
  .block__hover--readonly .block__wrapper {
    border: solid 1px transparent;
    box-shadow: none;
    .block__content:before,
    .block__content:after {
      border-top: none;
      border-bottom: none;
    }
    .table-manager-block {
      display: flex;
    }
  }
`;
